import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { StorageModule } from '@vlinder-web/storage-module-react';

import toast from 'react-hot-toast';
import { AppNavigatorService } from '@/AppNavigator';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const verifyOTP = async (context: any, event: any) => {
  const currentState = 'VALIDATE_OTP';
  const method = 'validateOTP';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.verifyOTP(event?.payload);
      console.log(`validateEmail service content:`, content);
      if (content) {
        return resolve({
          key: 'SET_PASSWORD',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'VERIFY_OTP_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'VERIFY_OTP_FAILED',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
